import React from "react";

const ToggleSwitch = ({ checked, onChange }) => {
    return (
        <div className="flex items-center gap-3">
            <label className="relative inline-flex items-center cursor-pointer select-none">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    className="sr-only"
                />
                <div
                    className={`relative w-[52px] h-[30px] rounded-full transition-all duration-300 ease-in-out shadow-inner
                    ${checked ? 'bg-green-500 shadow-[0_0_10px_2px_rgba(34,197,94,0.6)]' : 'bg-gray-300 shadow-[inset_0_0_5px_rgba(0,0,0,0.2)]'}`}
                >
                    <div
                        className={`absolute top-[4px] w-[22px] h-[22px] rounded-full bg-white shadow-md transform transition-all duration-300 ease-in-out
                        ${checked ? 'left-[26px] shadow-[0_0_6px_rgba(34,197,94,0.8)]' : 'left-[4px]'}`}
                    ></div>
                </div>
            </label>
        </div>
    );
};

export default ToggleSwitch;